import React, { useState } from "react";
import Menu from "@mui/material/Menu";
import { MenuItem } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { OpcoesSelecionaveisCheckBox } from "types/OpcoesSelecionaveisCheckBoxType";

interface OptionsCheckBoxProps {
  id: string;
  onChange: (opcao: OpcoesSelecionaveisCheckBox) => void;
  checked: boolean;
  disabled: boolean;
  indeterminate: boolean;
}

export const OptionsCheckBox: React.FC<OptionsCheckBoxProps> = (props) => {
  const [elementoReferencia, setElementoReferencia] = React.useState<null | HTMLElement>(null);
  const isOpenOptions = elementoReferencia != null;

  const handleOpenOptions = (event: React.MouseEvent<HTMLElement>) => {
    setElementoReferencia(event.currentTarget);
  };

  const handleCloseOptions = () => {
    setElementoReferencia(null);
  };

  const handleChangeOpcaoSelecionada = (opcao: OpcoesSelecionaveisCheckBox) => {
    props.onChange(opcao);
    handleCloseOptions();
  };
  return (
    <div>
      <Checkbox
        id={props.id}
        size={"small"}
        disabled={props.disabled}
        onClick={handleOpenOptions}
        checked={props.checked}
        indeterminate={!props.checked && props.indeterminate}
      />
      <Menu
        style={{ zIndex: 2002 }}
        anchorEl={elementoReferencia}
        anchorOrigin={{ vertical: 35, horizontal: 20 }}
        open={isOpenOptions}
        onClose={handleCloseOptions}
      >
        <MenuItem onClick={() => handleChangeOpcaoSelecionada("TODAS_FILTRO")} className="checkBox-option">
          Todas do filtro
        </MenuItem>
        <MenuItem onClick={() => handleChangeOpcaoSelecionada("TODAS_PAGINA")} className="checkBox-option">
          Todas da página
        </MenuItem>
        <MenuItem onClick={() => handleChangeOpcaoSelecionada("NENHUMA")} className="checkBox-option">
          Nenhuma
        </MenuItem>
      </Menu>
    </div>
  );
};
